/**
 * @generated SignedSource<<7f15647c24d1f64886a170df7f6fca40>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProductDetails_user$data = {
  readonly canShowSellerName: boolean | null;
  readonly " $fragmentType": "ProductDetails_user";
};
export type ProductDetails_user$key = {
  readonly " $data"?: ProductDetails_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProductDetails_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProductDetails_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "canShowSellerName",
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "581512bac8f0e17584528baa13f18b4b";

export default node;
